import Axios from 'axios';
import isObject from 'lodash/isObject';

const URL = (...props) => `/api/v2/files/${props.join('/')}`;

export async function Upload (files = [], statusCb = () => {}) {
    const formData = new FormData();

    files.map((file, id) => formData.append(`file[${id}]`, file));

    const { data } = await Axios.put(URL(), formData, {
        onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.floor(
                (progressEvent.loaded * 100) / progressEvent.total
            );
            statusCb({
                percentCompleted
            });
        }
    });
    return data;
}

export async function getFileInfo (id) {
	const { data } = await Axios.get(URL(id));
	return data;
}

export function getFileUrl (id, defaultImage = null) {
	if (!id) return defaultImage;
	if (isObject(id) && id.url) return id.url;
	const checkForHexRegExp = new RegExp("^[0-9a-fA-F]{24}$")
	if(!checkForHexRegExp.test(id)) return id;
	return URL('get', id);
}
